/**
 * The mark, by filename.
 *
 * **The bytes in `packages/brand/assets/` are the canonical ones**, and every surface still
 * serves its own copy — each deployable is self-contained, the marketing site is a
 * directory Cloudflare serves whole, and neither of those is worth changing to save 228 KB.
 * What makes "canonical" a fact rather than a claim is
 * `tests/invariants/every-surface-serves-the-same-mark.test.ts`, which compares the bytes.
 *
 * The names are exported because a surface should not spell them again: the mobile build
 * resolves them through this package's `./assets/*` export rather than committing a fourth
 * copy, and `icon-512` is the source for the iOS 1024 icon and the Android adaptive
 * foreground. **Composed from the mark, never redrawn** — a generated letter-tile shipped
 * here once, which is why the `branding` skill exists.
 *
 * `og-image.png` is deliberately absent: it is a share card for public pages, the marketing
 * site is the only surface with any, and an auth or control surface is `noindex`.
 */
export const MARK_FILES = ["icon-32.png", "icon-180.png", "icon-512.png"] as const;

export type MarkFile = (typeof MARK_FILES)[number];
